export default __webpack_public_path__ + "static/media/step4.0028727a.mp4";